/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// native components
import NoticeOfLongTermCareForm from './components/noticeOfLongTermCareForm';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      useReCaptcha
      disableDisclaimerTopBorder={false}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Claims',
          linkUrl: '/claims/',
          linkAriaLabel: 'Northwestern Mutual Claims',
        },
        {
          pageName: 'Notice of Long Term Care',
          linkUrl: '/notice-of-long-term-care-form/',
        },
      ]}>

      {/* NOTICE OF LONG TERM CARE FORM */}
      <NoticeOfLongTermCareForm />

    </Page>
  );
};
